import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

/**
 * ActionCard
 * - Accepts `to` (internal link) OR `href` (external)
 * - Clean minimal Fundo design
 * - Fully supports dark mode
 */
export const ActionCard = ({ title, icon, to, href, className }) => {
  const Wrapper = to ? Link : 'a';
  const linkProps = to ? { to } : { href };

  return (
    <motion.div
      whileHover={{ y: -4 }}
      transition={{ duration: 0.2 }}
      className={clsx(
        'rounded-xl border shadow-sm hover:shadow-md transition-all cursor-pointer',
        'bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-800',
        className
      )}
    >
      <Wrapper
        {...linkProps}
        className="flex items-center gap-4 p-5 focus:outline-none focus-visible:ring-2
          focus-visible:ring-fundo-green-300 dark:focus-visible:ring-fundo-green-700
          rounded-xl"
      >
        {/* Icon Badge */}
        <span
          className="
            p-3 rounded-lg border shadow-sm
            bg-fundo-green-50 text-fundo-green-700 border-fundo-green-100
            dark:bg-fundo-green-900 dark:text-fundo-green-300 dark:border-gray-700
          "
        >
          {icon}
        </span>

        {/* Title */}
        <p className="text-lg font-semibold text-gray-800 dark:text-gray-100">{title}</p>
      </Wrapper>
    </motion.div>
  );
};
